import { Injectable, inject } from '@angular/core';
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ActivityWizardStore } from '../../pages/features/distribuzione-censimento/attivita/activity-wizard/store/activity-wizard.store';
import { ConfirmationService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ActivityWizardDeactivateGuard implements CanDeactivate<any> {
  protected readonly activityWizardStore = inject(ActivityWizardStore);
  private confirmationService = inject(ConfirmationService);

  canDeactivate(
    component: any, // The component instance being deactivated
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot | undefined,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // if (component.skipDeactivateGuard) {
    //   return true;
    // }

    if (this.activityWizardStore.hasRecoverableSession()) {
      return new Promise((resolve) => {
        this.confirmationService.confirm({
          message:
            'Hai delle modifiche non salvate. Sei sicuro di voler uscire?',
          header: 'Conferma Uscita',
          rejectButtonStyleClass: 'p-button-outlined px-8',
          acceptButtonStyleClass: 'px-8',
          acceptLabel: 'Si',
          accept: () => {
            this.activityWizardStore.resetWizard();
            resolve(true);
          },
          reject: () => {
            resolve(false);
          },
        });
      });
    }

    // If there's no recoverable session, allow deactivation without prompting.
    return true;
  }
}
